module.exports = "up-arrow"